import { IDictionary } from '@bimser/core';

export { calculateAllowEditing } from './calculateAllowEditing';
export { calculateAllowFiltering } from './calculateAllowFiltering';
export { calculateAllowSearch } from './calculateAllowSearch';
export { calculateAllowSorting } from './calculateAllowSorting';
export { calculateDataType } from './calculateDataType';
export { calculateDBType } from './calculateDBType';
export { calculateFormat } from './calculateFormat';
export { calculateSelectedFilterOperation } from './calculateSelectedFilterOperation';
export { calculateShowEditorAlways } from './calculateShowEditorAlways';
export {
	convertFieldsForMapping,
	getFieldAsTreeSelectItem,
	getFieldsDataForFormulaManager,
	getFilteredFieldsAsTree
} from './convertFieldToTreeData';
export {
	deepMergeFormItems,
	isDMSecretModified,
	mergeDataAndView,
	normalizeItemsForServer
} from './deepMergeFormItems';
export { duplicateAlert } from './duplicateAlert';
export { FileToBase64 } from './fileToBase64';
export { getCollectionText } from './getCollectionText';
export { getCollectionTitle } from './getCollectionTitle';
export { getDataSourceData } from './getDataSourceData';
export { getDataSourceParams } from './getDataSourceParams';
export { geti18nValue } from './geti18nValue';
export { getMLText } from './getMLText';
export { getResultData } from './getResultData';
export { getTriggeredRules } from './getTriggeredRules';
export { nullItemAlert } from './nullItemAlert';
export { setPanelChildren } from './setPanelChildren';

export const FormSharedVariables: IDictionary<any> = {};
